import React from 'react';
import * as Carousels from '../../carousel';
export const UnmemoizedCarouselItem = ({ index, item: collectionItem, isLoading, scrollMap, }) => {
    const { item } = collectionItem || {};
    const isLoadingOrMock = isLoading || !item.id || item.id < 0;
    switch (item.__typename) {
        case 'Carousel':
            return React.createElement(Carousels.Standard, { index: index, carousel: item, isLoading: isLoadingOrMock });
        case 'Collection':
            if (isLoadingOrMock) {
                return React.createElement(Carousels.CollectionDisplay, { index: index, isLoading: true });
            }
            else {
                return React.createElement(Carousels.Collection, { index: index, collection: item, scrollMap: scrollMap, data: item.items });
            }
        default:
            return null;
    }
};
export const CarouselItem = React.memo(UnmemoizedCarouselItem, ({ item: prev, index: prevIdx }, { item: next, index: nextIdx }) => {
    const prevItem = prev?.item;
    const nextItem = next?.item;
    const isItemIdIdentical = prevItem?.id === nextItem?.id;
    if (prevItem && nextItem && 'isEntitled' in prevItem && 'isEntitled' in nextItem) {
        return isItemIdIdentical;
    }
    return isItemIdIdentical && prevIdx === nextIdx;
});
//# sourceMappingURL=CarouselItem.js.map